import {environment} from '../../environment/environment';

const MAP_BASE_URL_RELEASE = 'https://map-release.ab.loc/';
const MAP_BASE_URL_PROD = 'https://map.a-bank.com.ua/';
const MAP_BASE_PARAMS = 'lang=uk&site_map=2';
export const mapFrameUrlRelease = `${MAP_BASE_URL_RELEASE}?${MAP_BASE_PARAMS}`;
export const mapFrameTerminalsUrlRelease = `${MAP_BASE_URL_RELEASE}?${MAP_BASE_PARAMS}&only_tco=1`;
export const mapFrameRampantUrlRelease = `${MAP_BASE_URL_RELEASE}?${MAP_BASE_PARAMS}&rampant=true`;
export const mapFrameUrlProd = `${MAP_BASE_URL_PROD}?${MAP_BASE_PARAMS}`;
export const mapFrameTerminalsUrlProd = `${MAP_BASE_URL_PROD}?${MAP_BASE_PARAMS}&only_tco=1`;
export const mapFrameRampantUrlProd = `${MAP_BASE_URL_PROD}?${MAP_BASE_PARAMS}&rampant=true`;

export const govFrpConditionsLink = 'https://bdf.gov.ua/programs/dostupni-kredyty-5-7-9/';
export const aExpressTariffsLink =
    environment.url + '/backend/api/v1/pages/media/file?path=business/a-express/a-expres.pdf';
export const yuoTariffsLink =
    environment.url + '/backend/api/v1/pages/media/file?path=business/rko/fop_accounts_tariffs.pdf';
export const openFopLink = 'https://link.a-bank.com.ua/openFOP';
export const personalDataAppLink = 'https://a-bank.com.ua/24';
export const personalDataTelegramLink = 'https://t.me/abank_docs_bot';
export const personalDataViberBotLink = 'viber://pa?chatURI=abank';
export const personalDataTelegramBotLink = 'https://t.me/abank_bot';
export const downloadA24 = 'https://a-bank.com.ua/24';
export const openAccountBusinessFOP = 'https://abank.go.link/2zdcx '; // business/fop banner button
export const aBank24forBusiness = 'http://ab.a-bank.com.ua';
export const wuBannerLink =
    'https://www.westernunion.com/global-services/find-locations?WUCountry=ua&WULanguage=uk'; // transfers/wu banner button redesign
export const wu = 'https://www.westernunion.com/ua/uk/find-locations.html'; // transfers/wu banner button
export const payoneer = 'https://tracking.payoneer.com/aff_c?offer_id=512&aff_id=43317&url_id=1134'; // transfers/payoneer banner button

export const remitbee = 'https://www.remitbee.com/'; // transfers/remitbee banner button
export const globus = 'https://globusbank.com.ua/ua/mps-hlobus.html';
export const chooseRiaServicePoint = 'https://www.riamoneytransfer.com/';
export const mobileAcquiringGooglePlay =
    'https://play.google.com/store/apps/details?id=ua.com.abank.pay';
export const terms = 'https://conditions-and-rules.a-bank.com.ua';
export const UkrainiansTogetherCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_UR_ua.pdf';
export const greenCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_ua.pdf';
export const instantCashTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/MTG/Tarif_MTG.pdf';
export const boltCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_Bolt.pdf';
export const prostorCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_Prostor.pdf';
export const eVidnovlenniaCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Tarif_eVid.pdf';
export const vygodaCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Cart/Istot_Zelena_vygod_ua.pdf';
export const diiaCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Diya.pdf';
export const atbCardTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_ATB_ua.pdf';
export const paymentsTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Info_pay.pdf';
export const pensionTariffs =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zhovta_ua.pdf';
export const premiumCardTariffs =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Platinum_ua.pdf';
export const cahsbackUATariffs =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/MadeinUKR.pdf';
export const diia = 'https://erecovery.diia.gov.ua/';
export const AppGallery =
    'https://appgallery.huawei.com/app/C102212413?sharePrepath=ag&locale=uk_uk';
export const Itunes = 'https://itunes.apple.com/us/app/abank24/id1261267716?ls=1&mt=8';
export const paymentsSystem =
    'https://bank.gov.ua/ua/payments/payment-systems/d46d4d387e24410f9593a9413b1469a8';
export const depositHref = 'https://a-bank.com.ua/deposits#frame';
export const onlineDeposit = 'https://a-bank.com.ua/static/deposit/online_deposit_conditions.pdf';
export const aboutTop2022link_1 = '/static/committe_manage_risks_2022.pdf';
export const aboutTop2022link_2 = '/static/committe_remuneration_appointments_2022.pdf';
export const aboutTop2022link_3 = '/static/committee_on_issues_of_audit_2022.pdf';

export const minfinLink = 'https://minfin.com.ua/company/a-bank/review/';
export const pbpCredit = 'https://t.me/chasti_abankbot';
export const rozetka = 'https://rozetka.com.ua/';
export const comfy = 'https://comfy.ua/dnipro/';
export const assol = 'https://assol.in.ua/';
export const ukrzoloto = 'https://ukrzoloto.ua/uk';
export const zolotoyvek = 'https://zolotoyvek.ua/ua';
export const storeInUa = 'https://storeinua.com/';
export const shina = 'https://shina.ua/';
export const touch = 'https://touch.com.ua/ua';
export const yabloki = 'https://yabloki.ua/';
export const allo = 'https://allo.ua/';
export const epicentrk = 'https://epicentrk.ua/';
export const ktc = 'https://ktc.ua/';
export const moyo = 'https://www.moyo.ua/';
export const foxtrot = 'https://www.foxtrot.com.ua/';
export const jabko = 'https://jabko.ua/';
export const ctrs = 'https://www.ctrs.com.ua/';
export const pbp_api_docs = 'https://sites.google.com/a-bank.com.ua/api-abank?usp=sharing';
export const brend_thing_pbp =
    'https://drive.google.com/drive/folders/1mCdp33iHT4J3qNNsEtNsQNfXIRkTkFCQ';
export const recordVideoInterview85 = 'https://-abank-.playhunt.io/welcome/hfm01l93';
export const recordVideoInterview89 = 'https://-abank-.playhunt.io/welcome/hfhpnk3g';
export const recordVideoInterview73 = 'https://-abank-.playhunt.io/welcome/hfhpnk3g';
export const atbMarketPromo1 = 'https://www.atbmarket.com/promo/micni';
export const atbMarketPromo2 =
    'https://podorozhnyk.ua/promo/znizhka-3percent-v-aptekah-podorozhnik-z-kartkoyu-atb/';
export const atbMarketPromo3 =
    'https://www.atbmarket.com/legal-promotions/kosikovij-marafon-z-kartkou-atb-vid-visa';
export const businessBannerAward =
    'https://smebanking.agency/digital-banking-2025-top20-sme-banks-by-countries/';
export const businessBannerAwardFop =
    'https://smebanking.agency/cental-asia/digital-banking-2025-top20-sme-banks-by-countries/';
export const businessAllCreditProductAwardLink =
    'https://psm7.com/awards-2025/nomination/company/bank-product-business/';
export const businessAllDigitalAwardLink =
    'https://psm7.com/awards-2025/nomination/company/best-digital-bank/';
export const businessAllAcquiringAwardLink =
    'https://psm7.com/awards-2025/nomination/company/acquiring-bank/';
export const expressEnergyEpicentr = 'https://b2b.epicentrk.ua/shop/energoobespechenie/';
export const expressEnergyFoxtrot = 'https://www.foxtrot.com.ua/uk/shop/generators.html';
export const expressEnergyDarex = 'https://darex.energy/engine/baudouin-uk/';
export const expressEnergyAnthurium = 'https://anthurium.com.ua/';
export const expressEnergyVolta = 'https://www.volta.com.ua/company/';
export const expressEnergyKelte =
    'https://hotza.com.ua/lifepo4-komplekt-10-kvt10-kvt-zariadna-stantsiia-rezervne-zhyvlennia-akumuliator-dlia-kvartyry-ofisu-budynku/';
export const tokmakDiesel = 'https://tokmakdiesel.com.ua/';
export const expressEnergyGeneracia = 'https://generacia.energy/';
export const expressEnergySunot = 'https://sunotpoltava.com.ua/#subscribe';
export const expressEnergyFreedomEnergy = 'https://www.freedomenergyua.com';
export const expressEnergySinergy = 'https://www.sinergy-ukraine.com/';
export const expressEnergyDosvid = 'https://www.dosvid.com.ua/about-us/';
export const expressEnergyCitrus = 'https://www.ctrs.com.ua/mobilnye-istochniki-pitaniya/';
export const expressEnergySolarGarden = 'https://www.solargarden.com.ua/';
export const expressEnergyOnlySolar = 'https://onlysolar.in.ua/';
export const applyDarex =
    'https://corploans.a-bank.com.ua/?utm_source=google&utm_medium=organic&utm_campaign=darex&utm_content=link&utm_term=partner';
export const applyOnlySolar =
    'https://corploans.a-bank.com.ua/?utm_source=google&utm_medium=organic&utm_campaign=onlysolar&utm_content=partner';
export const applyEnergySpecialOfferDefault = 'https://corploans.a-bank.com.ua/';
export const tariffsKidCard =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Cart/%D0%9Aids.pdf';
export const pr_page_wiget_link = 'https://stage.snapwidget.com/embed/599887';
export const pr_page_wiget_rabota_facebook = 'https://snapwidget.com/embed/1095721';
export const pr_page_wiget_rabota_instagram = 'https://snapwidget.com/embed/1095720';
export const pr_page_wiget_oficial_instagram = 'https://snapwidget.com/embed/1096392';
export const pr_page_wiget_tiktok = 'https://snapwidget.com/embed/1095725';
export const pr_page_wiget_youtube = 'https://snapwidget.com/embed/1095918';

export const pr_page_subscribe_tiktok = 'https://www.tiktok.com/@abank_official';
export const pr_page_subscribe_facebook = 'https://www.facebook.com/abank.dp.ua?locale=uk_UA';
export const pr_page_subscribe_facebook_robota =
    'https://www.facebook.com/robotaabank?locale=uk_UA';
export const pr_page_subscribe_instagram = 'https://www.instagram.com/abank_official/';
export const pr_page_subscribe_instagram_robota = 'https://www.instagram.com/robotaabank/';
export const pr_page_subscribe_youtube = 'https://www.youtube.com/channel/UC5UByAW-8_zgjZoAu8LbvRQ';
export const govUaRia =
    'https://bank.gov.ua/ua/payments/payment-systems/8508e8dff4eed335fd6a56784830859f#%D0%90%D0%91%20%22%D0%A3%D0%9A%D0%A0%D0%93%D0%90%D0%97%D0%91%D0%90%D0%9D%D0%9A%22';
export const govUaMoneyGram =
    'https://bank.gov.ua/ua/payments/payment-systems/e849522905cd2225972b7bc154bc35e3';
export const govUaGLOBUS =
    'https://bank.gov.ua/ua/payments/payment-systems/9a6c25bf47173dc2f6567a79d9ad2f0f';
export const govUaVisa =
    'https://bank.gov.ua/ua/payments/payment-systems/e48247d63984aa482285bee70ff8e2b3';
export const govUaMasterCard =
    'https://bank.gov.ua/ua/payments/payment-systems/8c01297f1693f449128451a25feaeaf2';
export const govUaProstir =
    'https://bank.gov.ua/ua/payments/payment-systems/5a46e3b7627a2082524cbcf6ba44c929';
export const govUaWU =
    'https://bank.gov.ua/ua/payments/payment-systems/ae31031ea63a78448e3e62ec40780ad5';
export const govUaIntelExpress =
    'https://bank.gov.ua/ua/payments/payment-systems/279af94cc180aac96016c18462c05af7';
export const govUaSEP =
    'https://bank.gov.ua/ua/payments/payment-systems/15842cd0760c37197497d712a4a5c778';

export const FRPgovLink = 'https://zakon.rada.gov.ua/laws/show/28-2020-%D0%BF#Text';

export const orderAtbCardLink = 'https://abank.go.link/av13u';
export const youtubeUpdateDataLink = 'https://www.youtube.com/embed/tLcwzgYlAgI';
export const googlePlayLink = 'https://play.google.com/store/apps/details?id=ua.com.abank';
export const appStoreLink = 'https://apps.apple.com/ua/app/abank24/id1261267716?l=uk';
export const appGalleryLink =
    'https://appgallery.huawei.com/app/C102212413?sharePrepath=ag&locale=uk_uk';
export const transferBonusLink = `${environment.url}/backend/api/v1/pages/media/file?path=deposit/transfer-bonus/transfer-bonus.pdf`;
export const instantCashLink = 'https://a-bank.com.ua/24';
export const planetAvtoLink = 'https://planetavto.ua/'; // services/auto-leasing banner button
export const energoCreditLink = 'https://energycredit.bdf.gov.ua/'; // business/gov/frp energocredit block button
export const openBankingLink =
    'https://api-dev-portal.a-bank.com.ua/api/swagger-ui/index.html#/1.%20%D0%9E%D0%BF%D0%B5%D1%80%D0%B0%D1%86%D1%96%D1%97%20%D0%B7%D1%96%20%D0%B7%D0%B3%D0%BE%D0%B4%D0%BE%D1%8E/processAccountAccessConsent';
export const safeBoxesTariffsLink = 'https://a-bank.com.ua/backend/api/v1/condition/pdf/uk/979'; // services/safe_boxes tariffs btn
export const creditLineTariffsLink =
    environment.url + '/backend/api/v1/pages/media/file?path=business/credit-line/creditline.pdf';
export const govCashbackConditionsLink =
    'https://www.kmu.gov.ua/npas/pro-realizatsiiu-eksperymentalnoho-proektu-shchodo-nadannia-derzhavnoi-hroshovoi-dopomohy-s952200824';
export const govCashbackUsageLink =
    'https://me.gov.ua/Documents/List?lang=uk-UA&id=1ca5c31f-1f70-4c81-b8a5-6f93a92e4b32&tag=FormuvanniaPerelikuTekhnikiIObladnanniaVitchiznianogoVirobnitstva-VartistYakikhChastkovoKompensutsiaZaRakhunokBiudzhetnikhKoshtiv-promisloviiKeshbek15-';
export const wogUkrainiansTogetherLink = 'https://wog.ua/ua/wog-ta-ukrayinci-razom/';
export const creditProtectionTasLink = 'https://sgtas.ua/rozkryttia_informatsii/ ';
export const creditProtectionInfoLink = 'https://sgtas.ua/kredytnyj_zahyst_inform_07.08.2025/';
export const creditProtectionConditionsLink = 'https://sgtas.ua/kredytnyj_zahyst_zusp_07.08.2025/';
export const insuranceDocumentsTasCompanyLink = 'https://sgtas.ua/rozkryttia_informatsii/';
export const insuranceDocumentsTasProductLink = 'https://sgtas.ua/tas-travel_inform_16.12.24/';
export const insuranceDocumentsUniversalnaCompanyLink =
    'https://universalna.com/financial-documents/general-information/';
export const insuranceDocumentsUniversalnaProductLink =
    'https://universalna.com/documents/offers/ID-16_31_12_24.pdf';
export const insuranceDocumentsVusoCompanyLink = 'https://vuso.ua/informations';
export const insuranceDocumentsVusoProductLink =
    'https://drive.google.com/file/d/1vcwthFCZWxgLUIW598QGgZN0HDjfnD3R/edit';
export const insuranceDocumentsArxCompanyLink =
    'https://arx.com.ua/publichna-ta-finansova-informatsiya';
export const insuranceDocumentsArxProductLink =
    'https://arx.com.ua/uploads/468/%D0%86%D0%BD%D1%84%D0%BE-%D0%B4%D0%BE%D0%B2%D1%96%D0%B4%D0%BA%D0%B0-%D0%A2%D1%83%D1%80%D0%B8%D1%81%D1%82%D0%B8%D1%87%D0%BD%D0%B5-%D1%81%D1%82%D1%80%D0%B0%D1%85%D1%83%D0%B2%D0%B0%D0%BD%D0%BD%D1%8F.pdf';
export const insuranceDocumentsEuroinsCompanyLink =
    'https://www.euroins.com.ua/informaciya-dlya-kliyentiv';
export const insuranceDocumentsEuroinsProductLink =
    'https://www.euroins.com.ua/storage/app/media/products_info/44_Trevel_Info.pdf';
export const insuranceDocumentsUniqaCompanyLink = 'https://uniqa.ua/initial_data/';
export const insuranceDocumentsUniqaProductLink =
    'https://uniqa.ua/storage/insurance-products/reports-files/1618_IDSSP_14.02.2025.pdf';
export const insuranceDocumentsIngoCompanyLink =
    'https://ingo.ua/publichna-ta-finansova-informacziya';
export const insuranceDocumentsIngoProductLink =
    'https://ingo.ua/cms/image/uploads/Zagalni_umovi_kompleksnogo_strahovogo_produktu_Kompleksne_Strahuvannya_osib_yaki_podorozhuyut_abo_pribuvayut_v_krayinu_na_timchasove_perebuvannya_981ee435dd.pdf?v=1719819513408';
export const insuranceDocumentsUsgCompanyLink = 'https://www.usg.ua/about/company-presentation/';
export const insuranceDocumentsUsgProductLink =
    'https://api.usg.ua/public-docs/about/terms-and-conditions/informational-documents/17xe3g1hg_53._Informatsiinii_dokument_pro_standartnii_strakhovii_produkt._Kompleksne_turistichne_strakhuvannya.pdf';
export const insuranceDocumentsPzuCompanyLink = 'https://www.pzu.com.ua/about/public-info.html';
export const insuranceDocumentsPzuProductLink =
    'https://www.pzu.com.ua/admin/upload/2025/doc-product/inform-doc-turyzm-za-kordonom.pdf';
export const insuranceDocumentsRespectCompanyLink = 'https://respectins.com/official-info/';
export const insuranceDocumentsRespectProductLink =
    'https://respectins.com/wp-content/uploads/2025/01/%D0%86%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D1%96%D0%B9%D0%BD%D0%B8%D0%B9-%D0%B4%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82-%D0%BF%D0%BE%D0%B4%D0%BE%D1%80%D0%BE%D0%B6%D1%83%D1%8E%D1%87%D1%96-%D0%B7%D0%B0-%D0%BA%D0%BE%D1%80%D0%B4%D0%BE%D0%BD-%D0%B2%D1%96%D0%B4-31.01.2025.pdf';
export const insuranceDocumentsInterExpressCompanyLink =
    'https://www.interexpress.com.ua/vidomosti_pro_sk_interexpress';
export const insuranceDocumentsInterExpressProductLink =
    'https://interexpress.com.ua/wp-content/uploads/2024/vzk/ID_VZK-2.pdf';
export const insuranceDocumentsEuroTravelinsCompanyLink =
    'https://eurotravelins.com.ua/ua/publichna-informacija/informacija-vidpovidno-do-zu-pro-finansovi-poslugi/';
export const insuranceDocumentsEuroTravelinsProductLink =
    'https://eurotravelins.com.ua/upload/zagalni_umovi/IDSSP_Strakhuvannja_vitrat_pov_jazanikh_z_nadannjam_dopomogi__asistans___pid_chas_zdiisnennja_podorozhi_za_kordon_Ukrajini.pdf';
export const insuranceDocumentsTasLifeCompanyLink =
    'https://taslife.com.ua/important_info/rozkryttya-informacziyi/rozkryttya-informacziyi';
export const insuranceDocumentsTasLifeProductLink =
    'https://taslife.com.ua/dokuments/informaczijnyj-dokument-pro-standartnyj-strahovyj-produkt-medychne-strahuvannya-podorozhuyuchyh';
export const insuranceDocumentsInskCompanyLink = 'https://insk.com.ua/zagalni-vidomosti/';
export const insuranceDocumentsInskProductLink =
    'https://insk.com.ua/wp-content/uploads/2024/06/%D0%86%D0%A1%D0%9F-18-%D0%BA%D0%BB%D0%B0%D1%81.pdf';
export const insuranceDocumentsInterPolicyCompanyLink =
    'https://inter-policy.com/rozkrittya-informaczii/';
export const insuranceDocumentsInterPolicyProductLink =
    'https://inter-policy.com/wp-content/uploads/2024/06/2_inform_dokyment_za-kordon_z_01_07_2024.pdf';
export const insuranceDocumentsTasPrivateCompanyLink =
    'https://taslife.com.ua/important_info/rozkryttya-informacziyi/rozkryttya-informacziyi';
export const insuranceDocumentsTasPrivateProductLink =
    'https://taslife.com.ua/wp-content/uploads/2025/09/informatsiyniy-dokument-pro-standartniy-strahoviy-produkt-tviy-zahist.pdf';
export const insuranceDocumentsMetlifeCompanyLink =
    'https://www.metlife.ua/about-us/metlife-ukraine/';
export const insuranceDocumentsMetlifeProductLink =
    'https://www.metlife.ua/content/dam/metlifecom/ua/PDFs/business/financialinstitutions/Informationdocument_1class_ZKD.pdf';
export const insuranceDocumentsEiaCompanyLink = 'https://eia.com.ua/uk/about/fin/fin';
export const insuranceDocumentsArsenalCompanyLink =
    'https://arsenal-ic.ua/docs/consumers/informatsiya-pro-strahovika-onovleno-08102026.pdf';
export const insuranceDocumentsOrantaCompanyLink = 'https://oranta.ua/info/base-info';
export const insuranceDocumentsUticoCompanyLink = 'https://www.utico.ua/page/publichna-informaciya';
export const insuranceDocumentsGuardianCompanyLink = 'https://grdn.com.ua/rozkrittya-informacii';
export const insuranceIntermediaryInfoCompaniesGovLink = 'https://kis.bank.gov.ua/search-fu';
export const insuranceIntermediaryInfoArxLink = 'https://arx.com.ua/';
export const insuranceIntermediaryInfoVusoLink = 'https://vuso.ua';
export const insuranceIntermediaryInfoUniversalnaLink = 'https://universalna.com';
export const insuranceIntermediaryInfoUniqaLink = 'https://uniqa.ua';
export const insuranceIntermediaryInfoEiaLink = 'https://eia.com.ua';
export const insuranceIntermediaryInfoEurotravelinsLink = 'https://eurotravelins.com.ua';
export const insuranceIntermediaryInfoArsenalLink = 'https://arsenal-ic.ua';
export const insuranceIntermediaryInfoEuroinsLink = 'https://www.euroins.com.ua';
export const insuranceIntermediaryInfoIngoLink = 'https://ingo.ua';
export const insuranceIntermediaryInfoInterexpressLink = 'https://www.interexpress.com.ua';
export const insuranceIntermediaryInfoInterpolicyLink = 'https://inter-policy.com';
export const insuranceIntermediaryInfoOrantaLink = 'https://oranta.ua';
export const insuranceIntermediaryInfoPzuLink = 'https://www.pzu.com.ua';
export const insuranceIntermediaryInfoRespectinsLink = 'https://respectins.com';
export const insuranceIntermediaryInfoSgtasLink = 'https://sgtas.ua';
export const insuranceIntermediaryInfoUkringroupLink = 'https://ukringroup.ua';
export const insuranceIntermediaryInfoUticoLink = 'https://www.utico.ua';
export const insuranceIntermediaryInfoArxlifeLink = 'https://arx.com.ua/life';
export const insuranceIntermediaryInfoKniazhaLink = 'https://kniazha.ua/';
export const insuranceIntermediaryInfoTaslifeLink = 'https://taslife.com.ua/';
export const insuranceIntermediaryInfoInskLink = 'https://insk.com.ua/ua/';
export const insuranceIntermediaryInfoMetlifeLink = 'https://www.metlife.ua/';
export const insuranceIntermediaryInfoGuardianLink = 'https://grdn.com.ua/';
export const govApcConditionsLink = 'https://zakon.rada.gov.ua/laws/show/130-2017-%D0%BF#Text';
export const govApcUsageLink =
    'https://www.me.gov.ua/Documents/List?lang=uk-UA&id=db6ade26-b223-4214-9caf-b9f8b73b4d28&tag=KomisiiaZFormuvanniaPerelikuVitchiznianoiTekhnikiTaObladnanniaDliaAgropromislovogoKompleksu-VartistYakikhChastkovoKompensutsiaZaRakhunokKoshtivDerzhavnogoBiudzhetu';
export const govKmdaConditionsLink =
    'https://kyivcity.gov.ua/biznes_ta_litsenzuvannia/programa_finansovo-kreditno_pidtrimki_subyektiv_malogo_ta_serednogo_pidpriyemnitstva_u_misti_kiyevi/';
export const govLeasingConditionsLink =
    'https://bdf.gov.ua/programs/prohrama-dostupnyy-finansovyy-lizynh-5-7-9/';
export const insuranceMiniCascoDocumentsArxProductLink =
    'https://arx.com.ua/uploads/461/Informatsiia-pro-strakhovyi-produkt_MiniKASKO.pdf';
export const insuranceMiniCascoDocumentsUniqaProductLink =
    'https://uniqa.ua/storage/public-offer/partner-reports/4644_IDSSP_14.02.2025.pdf';
export const insuranceMiniCascoDocumentsEuroinsProductLink =
    'https://www.euroins.com.ua/storage/app/media/products_info/Info_KASKO_Light_EP.pdf';
export const insuranceMiniCascoDocumentsUniversalnaProductLink =
    'https://universalna.com/documents/offers/ID-vehicle_31_12_24.pdf';
export const insuranceMiniCascoDocumentsVusoProductLink =
    'https://drive.google.com/file/d/1p1TCvOGh3r5bgQNzB-9Ut8m1OcYf7T-r/view';
export const insuranceDefenceeverydayDocumentsTasPrivateProductLink =
    'https://taslife.com.ua/wp-content/uploads/2025/09/informatsiyniy-dokument-pro-standartniy-strahoviy-produkt-tviy-zahist.pdf';
export const insuranceDefenceeverydayDocumentsMetlifeProductLink =
    'https://www.metlife.ua/content/dam/metlifecom/ua/PDFs/business/financialinstitutions/Informationdocument_1class_ZKD.pdf';
export const insurancePolicyDocumentsArxProductLink =
    'https://arx.com.ua/information-document/356/informatsiia-pro-strakhovyi-produkt-avtotsyvilka';
export const insurancePolicyDocumentsArsenalProductLink =
    'https://arsenal-ic.ua/docs/ins-prod/44-Informatsiinyi-dokument-01-06-2026.pdf';
export const insurancePolicyDocumentsVusoProductLink =
    'https://services.vuso.ua/e-documents/api/files/get/37e50e61e512c56d7c0ca8014e94a8cb';
export const insurancePolicyDocumentsEuroinsProductLink =
    'https://www.euroins.com.ua/storage/app/media/products_info/Info_OSCPV.pdf';
export const insurancePolicyDocumentsEiaProductLink =
    'https://eia.com.ua/sites/default/files/1_informaciynyy_dokument_sp_avtocyvilka_z_01.01.2025.pdf';
export const insurancePolicyDocumentsIngoProductLink =
    'https://ingo.ua/cms/image/uploads/Informaczijnij_dokument_AVTO_Cz_IVILKA_18776d085b.pdf?v=1738325144506';
export const insurancePolicyDocumentsInterPolicyProductLink =
    'https://inter-policy.com/wp-content/uploads/2024/12/2_inform_dokument_avtotsyvilka_z_01_01_2025.pdf';
export const insurancePolicyDocumentsOrantaProductLink =
    'https://apifalcon.oranta.ua/files/9638faef-10ca-46f1-bf43-8f555dd91a5d';
export const insurancePolicyDocumentsPzuProductLink =
    'https://www.pzu.com.ua/admin/upload/2024/upload/Inform-document-product-autocivilka-z-01.01.2025.pdf';
export const insurancePolicyDocumentsTasProductLink =
    'https://sgtas.ua/oscpv_vnutr_inform_01.01.25/';
export const insurancePolicyDocumentsUniversalnaProductLink =
    'https://universalna.com/documents/offers/ID2_o_autotsyvilka.pdf';
export const insurancePolicyDocumentsUniqaProductLink =
    'https://uniqa.ua/storage/insurance-products/reports-files/omtpl_IDSSP_31.01.2025.pdf';
export const insurancePolicyDocumentsUsgProductLink =
    'https://api.usg.ua/pds/Informatsiinii_dokument_pro_standartnii_strakhovii_produkt_OSTsPV_(online)?_gl=1*1jxq1jb*_gcl_au*MTcyMDYxODc3OC4xNzM5NTM2MDMz*_ga*OTMwODE5Nzk2LjE3Mzk1MzYwMzQ.*_ga_1MPYTEZL6Q*MTczOTUzNjAzMy4xLjAuMTczOTUzNjA0NS40OC4wLjA';
export const insurancePolicyDocumentsUticoProductLink =
    'https://www.utico.ua/uploads/docs/static/b9da745a15d7194755e046b9cf57ef7c.pdf';
export const insurancePolicyDocumentsGuardianProductLink =
    'https://api-site.grdn.com.ua/storage/uploads/docs/oscpv-info-n5-240125.pdf';
export const insuranceGreenPolicyDocumentsVusoProductLink =
    'https://services.vuso.ua/e-documents/api/files/get/fe6eea4182b2dc423cc43170f46f4575';
export const insuranceGreenPolicyDocumentsIngoProductLink =
    'https://ingo.ua/cms/image/uploads/Informaczijnij_dokument_Zelena_kartka_3a960da1bb.pdf?v=1736937273300';
export const insuranceGreenPolicyDocumentsTasProductLink =
    'https://sgtas.ua/oscpv_mizhnar_inform_01.01.25/';
export const insuranceGreenPolicyDocumentsOrantaProductLink =
    'https://apifalcon.oranta.ua/files/5410c93f-040b-4a8c-bd44-e6df4e8f4954';
export const insuranceGreenPolicyDocumentsPzuProductLink =
    'https://www.pzu.com.ua/admin/upload/2024/upload/Inform-document-product-ZK-z-01.01.2025.pdf';
export const insuranceGreenPolicyDocumentsUticoProductLink =
    'https://www.utico.ua/uploads/docs/static/1fffd0f319c1b8ea209121c6efc54065.pdf';
export const transfersAttentionUrl =
    'https://a-bank.com.ua/backend/api/v1/pages/media/file?path=conditions-and-rules.pdf';
export const aboutGeneralPeopleRating = 'https://minfin.com.ua/banks/top/';
export const aboutGeneralStabilityRating = 'https://minfin.com.ua/banks/rating/';
export const aboutGeneralCapitalRating = 'https://bank.gov.ua/ua/statistic/supervision-statist#1';
export const aboutGeneralDepositsRating =
    'https://minfin.com.ua/banks/ranking/deposits-individual/2022/9/';
export const aboutGeneralCardsRating =
    'https://bank.gov.ua/ua/payments/oversite#169-statystyka-po-kartkah';
export const aboutGeneralCreditRating = 'https://bank.gov.ua/ua/statistic/supervision-statist#1';
export const aboutGeneralAbank24Rating =
    'https://play.google.com/store/apps/details?id=ua.com.abank';
export const aboutGeneralCardsAmount = 'https://bank.gov.ua/ua/payments/oversite';
export const aboutGeneralBranchesAmount = 'https://bank.gov.ua/ua/statistic/supervision-statist#1';
export const aboutGeneralDepositorsAmount =
    'https://bank.gov.ua/ua/statistic/supervision-statist#1';
export const eReceiptLink = 'https://echeck.me.gov.ua/';
export const kidCardMarathonConditionsLink =
    'https://a-bank.com.ua/backend/api/v1/pages/media/file?path=akcii/kids/my_first_card.pdf';
export const kidCardMarathonSignUpLink =
    'https://darwinland.com/marathon_card_abank/?utm_source=abank&utm_campaign=card_abank&utm_medium=partner';
export const a24QuickCashLink = 'https://abank24.page.link/yiCT';
export const contactsAppleMessengesClientHelpLink =
    'https://bcrw.apple.com/urn:biz:bd844618-a647-47cf-8056-e3a43bfb76c4';
export const contactsTelegramSocialsLink = 'https://t.me/zayacNews';
export const contactsXSocialsLink = 'https://x.com/abank_ukr?s=11&t=vlfJ2WsCySxf4F_V0-ePYg';
export const contactsFacebookSocialsLink = 'https://www.facebook.com/abank.dp.ua/';
export const contactsInstagramSocialsLink =
    'https://www.instagram.com/abank_official/?igshid=zvu6ul27gt3y';
export const contactsTikTokSocialsLink = 'https://vm.tiktok.com/ZMRftsaKa/';
export const contactsThreadsSocialsLink = 'https://www.threads.com/@abank_official?invite=0';
export const lightHouseUsageLinkDiia =
    'https://diia.gov.ua/services/dopomoha-bahatokvartyrnym-budynkam-na-enerhostiikist'; // business/gov/light-house usage-service btn 1
export const lightHouseUsageLink = 'https://svitlodim.gov.ua/'; // business/gov/light-house usage-service btn 2
export const fatcaLinkFW9 = 'https://www.irs.gov/pub/irs-pdf/fw9.pdf';
export const fatcaLinkFW8BEN = 'https://www.irs.gov/pub/irs-pdf/fw8ben.pdf';
export const fatcaLink3FW8BENE = 'https://www.irs.gov/pub/irs-pdf/fw8bene.pdf';
export const fatcaLinkIrs = 'https://www.irs.gov';
export const crsLinkTax = 'https://tax.gov.ua/baneryi/crs';
export const crsLinkMof = 'https://www.mof.gov.ua/uk/crs-578';
export const crsLinkI =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/CRS/CRS-I_form_instructions.pdf';
export const crsLinkE =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/CRS/CRS-E_form_instructions.pdf';
export const crsLinkCP =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/CRS/CRS-CP_form_instructions.pdf';
export const dynamoLink = 'https://fcdynamo.com/';
export const servicesPaymentsTariffsLink =
    'https://conditions-and-rules.a-bank.com.ua/main/view-content-487/?lang=uk';
export const cpgEnergyLink = 'https://cpg.energy/wattsonic/';
export const newPensionClientPdf = '/static/services/pension/new_pension_client_1000_promo.pdf';
export const benefitsMilitaryPersonnelZakonLink =
    'https://zakon.rada.gov.ua/laws/show/2011-12/paran245#n245';
export const fiscalizationMoreLinkEcheck =
    'https://e-check.com.ua/?utm_campaign=A_Bank_VISA_TTP&utm_medium=referral_web&_branch_referrer';
export const fiscalizationMoreLinkPayKitPOS = 'https://paykitpos.com/';
export const fiscalizationMoreLinkCashalot = 'https://cashalot.ua/';
export const fiscalizationMoreLinkSmPos = 'https://www.smpos.app/';
export const fiscalizationMoreLinkCheckbox = 'https://checkbox.ua/';
export const fiscalizationMoreLinkOnlineKasa = 'https://onlinekasa.binotel.ua/';
export const fiscalizationMoreLinkSmartKasa = 'https://www.smartkasa.ua/';
export const fiscalizationMoreLinkVchasno = 'https://kasa.vchasno.com.ua/programnyj-rro-dlya-fop';
export const fiscalizationGooglePlayLinkEcheck =
    'https://play.google.com/store/apps/details?id=e_check.prod_2_0';
export const fiscalizationGooglePlayLinkPayKitPOS =
    'https://play.google.com/store/apps/details?id=chmsoft.org.paykitpos';
export const fiscalizationGooglePlayLinkCashalot =
    'https://play.google.com/store/apps/details?id=com.medoc.cashalot&gl=UA';
export const fiscalizationGooglePlayLinkSmPos =
    'https://play.google.com/store/apps/details?id=com.TFPK.SMPos';
export const fiscalizationGooglePlayLinkCheckbox =
    'https://play.google.com/store/apps/details?id=ua.in.checkbox';
export const fiscalizationGooglePlayLinkOnlineKasa =
    'https://play.google.com/store/apps/details?id=com.binotel.onlinekasa';
export const fiscalizationGooglePlayLinkSmartKasa =
    'https://play.google.com/store/apps/details?id=com.smart.kasa';
export const fiscalizationGooglePlayLinkVchasno =
    'https://play.google.com/store/apps/details?id=ua.vchasno.kasa&hl=uk-UA';
export const taptophoneAPayLink = 'https://play.google.com/store/apps/details?id=ua.com.abank.pay';
export const fiscalizationMoreLinkServio = 'https://serviosoft.com/';
export const fiscalizationMoreLinkShopExpress =
    'https://shop-express.ua/ukr/platform/integration/a-bank/';
export const fiscalizationMoreLinkEatScanPay = 'https://eatscanpay.com/';
export const fiscalizationMoreLinkStravopys =
    'https://stravopys.com/uk/blog/guides/internet-acquiring-from-abank';
export const fiscalizationMoreLinkChekly =
    'https://chekly-app.com/abank?utm_source=a-bank&utm_medium=referral&utm_campaign=a_bank_partnership&utm_content=chekly_article';
export const fiscalizationMoreLinkWordPress = 'https://uk.wordpress.org/plugins/abank-pay/';
export const fiscalizationMoreLinkOpenChart =
    'https://www.opencart.com/index.php?route=marketplace/extension/info&member_token=33af3a1fa795e22631a89720e03f18bf&extension_id=47893&filter_search=%D0%B0%D0%B1%D0%B0%D0%BD%D0%BA';
export const fiscalizationMoreLinkNetHunt = 'https://nethunt.ua/integrations/abank';
export const fiscalizationMoreLinkKey = 'https://ua.keycrm.app/integrations/abank';
export const fiscalizationMoreLinkUspacy =
    'https://uspacy.ua/support/knowledgebase/oplaty-cherez-abank/';
export const fiscalizationMoreLinkApi =
    'https://sites.google.com/a-bank.com.ua/api-e-commerce/%D0%BF%D1%80%D0%BE-%D1%81%D0%B5%D1%80%D0%B2%D1%96%D1%81?authuser=0';
